import { ValueFormField } from '@sitecore-jss/sitecore-jss-forms';
import { FieldChangeCallback, Label, type ListFieldProps } from '@sitecore-jss/sitecore-jss-react-forms';
import { FC, Fragment } from 'react';

import { FieldValidationErrors } from '../CustomFields/FieldValidationErrors';
import { getFormFieldAriaProps } from '../Functions/FormFieldAriaProps';

/**
 * Overrides the built-in Sitecore forms checkbox list.
 * @see [Original CheckboxList Implementation](https://github.com/Sitecore/jss/blob/v22.10.0/packages/sitecore-jss-react-forms/src/components/field-templates/checkbox-list.tsx)
 *
 * Markup and functionality should be 1:1 with the exception of `getFormFieldAriaProps`.
 *
 * @param props - CheckboxList properties.
 * @returns A checkbox list.
 */
export const BaseCheckboxList: FC<ListFieldProps> = (props) => {
  const { errors, field, onChange, tracker, value } = props;

  return (
    <Fragment>
      <Label {...props} />
      {field.model.items.map((item, index) => (
        <label key={item.itemId}>
          <input
            type="checkbox"
            className={field.model.cssClass}
            id={field.valueField.id + index}
            name={field.valueField.name}
            value={item.value}
            checked={value.some((v) => v === item.value)}
            onChange={(e) => handleOnChange(field, value, e.target.value, e.target.checked, onChange)}
            onFocus={() => tracker.onFocusField(field, value)}
            onBlur={() => tracker.onBlurField(field, value, errors)}
            {...getFormFieldAriaProps(field, errors)}
          />
          {item.text}
        </label>
      ))}
      <FieldValidationErrors {...props} />
    </Fragment>
  );
};

function handleOnChange(
  field: ValueFormField,
  originalFieldValue: string[],
  changedElement: string,
  checked: boolean,
  callback: FieldChangeCallback
) {
  let value = originalFieldValue;

  if (checked) {
    value.push(changedElement);
  } else {
    value = value.filter((v) => v !== changedElement);
  }

  callback(field.valueField.name, value, true, []);
}
